import React from "react";
import { times } from "lodash";
import Challenge from "./Challenge";

const hintRowCount = 60;
const hintColumnCount = 100;

const hintElements = ["+", "sum", "series", "symbol", "add", "addition"];
const hintElement = times(hintRowCount, row =>
  times(
    hintColumnCount,
    _ => hintElements[Math.floor(Math.random() * hintElements.length)]
  )
);

export default props => (
  <Challenge
    rowCount={hintRowCount}
    columnCount={hintColumnCount}
    useSingleHints={true}
    getHintElement={(i,j) => hintElement[i][j]}
    titleText="it adds up"
    acceptedRune="sigma"
    {...props}
  />
);




// WEBPACK FOOTER //
// ./src/components/challenges/SigmaChallenge.js